import outputs from 'root/cfOutput';
import { isProdEnv } from 'root/src/shared/util/envSelect';
const { domainName } = outputs;
export var TranslatedLanguagesCodes;
(function (TranslatedLanguagesCodes) {
    TranslatedLanguagesCodes["En"] = "en";
    TranslatedLanguagesCodes["Es"] = "es";
    TranslatedLanguagesCodes["Br"] = "pt-br";
    TranslatedLanguagesCodes["Pt"] = "pt";
    TranslatedLanguagesCodes["Fr"] = "fr";
    TranslatedLanguagesCodes["De"] = "de";
    TranslatedLanguagesCodes["It"] = "it";
    TranslatedLanguagesCodes["Ja"] = "ja";
    TranslatedLanguagesCodes["Pl"] = "pl";
})(TranslatedLanguagesCodes || (TranslatedLanguagesCodes = {}));
export const REVERSED_LANGUAGES_CODES = {
    [TranslatedLanguagesCodes.En]: 'en',
    [TranslatedLanguagesCodes.Es]: 'es',
    [TranslatedLanguagesCodes.Br]: 'br',
    [TranslatedLanguagesCodes.Fr]: 'fr',
    [TranslatedLanguagesCodes.De]: 'de',
    [TranslatedLanguagesCodes.It]: 'it',
    [TranslatedLanguagesCodes.Pt]: 'pt',
    [TranslatedLanguagesCodes.Ja]: 'ja',
    [TranslatedLanguagesCodes.Pl]: 'pl',
};
export const TRANSLATED_LANGUAGES_DOMAINS = [
    `es.${domainName}`,
    `pt-br.${domainName}`,
    `fr.${domainName}`,
    `de.${domainName}`,
    `it.${domainName}`,
    `pt.${domainName}`,
    `ja.${domainName}`,
    `pl.${domainName}`,
];
export const TRANSLATED_LANGUAGES_URL = {
    [TranslatedLanguagesCodes.En]: `https://${domainName}`,
    [TranslatedLanguagesCodes.Fr]: `https://fr.${domainName}`,
    [TranslatedLanguagesCodes.Br]: `https://pt-br.${domainName}`,
    [TranslatedLanguagesCodes.Pt]: `https://pt.${domainName}`,
    [TranslatedLanguagesCodes.Es]: `https://es.${domainName}`,
    [TranslatedLanguagesCodes.De]: `https://de.${domainName}`,
    [TranslatedLanguagesCodes.It]: `https://it.${domainName}`,
    [TranslatedLanguagesCodes.Pl]: `https://pl.${domainName}`,
    [TranslatedLanguagesCodes.Ja]: `https://ja.${domainName}`,
};
export const READABLE_TRANSLATED_LANGUAGES = {
    [TranslatedLanguagesCodes.En]: 'English',
    [TranslatedLanguagesCodes.Es]: 'Español',
    [TranslatedLanguagesCodes.Br]: 'Português (Brasil)',
    [TranslatedLanguagesCodes.Pt]: 'Português (Portugal)',
    [TranslatedLanguagesCodes.Fr]: 'Français',
    [TranslatedLanguagesCodes.De]: 'Deutsch',
    [TranslatedLanguagesCodes.It]: 'Italiano',
    [TranslatedLanguagesCodes.Ja]: '日本語',
    [TranslatedLanguagesCodes.Pl]: 'Polski',
};
export const WEGLOT_SCRIPT_URL = 'https://cdn.weglot.com/weglot.min.js';
export const weglotInitScript = (apiKey) => {
    return `Weglot.initialize({"api_key": "${apiKey}","cache": true,"hide_switcher": true })`;
};
export const WEGLOT_DNS_VALUE = isProdEnv ? '123d9afc.translate-cf.weglot.io.' : `${domainName}.`;
